import SemanticPageDocument from '@/components/semantic/SemanticPageDocument';
import { getSemanticPageByPath } from '@/lib/semantic-content/pages';
import NotFound from '@/pages/NotFound';

export default function MapleOSVsChromeOS() {
  const page = getSemanticPageByPath('/mapleos-vs-chromeos');

  return page ? <SemanticPageDocument page={page} /> : <NotFound />;
}
